import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: 'https://b5b7126c0effee8771d26febc6d7a686@o4509093844680704.ingest.de.sentry.io/4509093846450256',

});
export {Sentry}; 
